module.exports = __webpack_public_path__ + "static/turquia-012-6b0c49e07c5c76dd6827f6ca695cf2ee.jpg";